"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPasteInfo = void 0;

var _pastePreProcess = _interopRequireDefault(require("rich-text-lib/lib/pastePreProcess"));

var _embedSrc = require("rich-text-lib/utils/embedSrc");

var identity = function identity(x) {
  return x;
};

var getPasteInfo = function getPasteInfo(event, editor, _ref) {
  var formatTransformMap = _ref.formatTransformMap,
      clearAllStyles = _ref.clearAllStyles,
      defaultStylesMap = _ref.defaultStylesMap,
      allowEmbedUrlPasting = _ref.allowEmbedUrlPasting;
  var dataTransfer = event.clipboardData || editor.getDoc().dataTransfer;

  if (dataTransfer && dataTransfer.getData) {
    if (allowEmbedUrlPasting) {
      var embedData = (0, _embedSrc.convertUrlToEmbedData)(dataTransfer.getData('text/plain'));

      if (embedData) {
        return {
          type: 'plaintext',
          embedData: embedData
        };
      }
    }

    if (dataTransfer.getData('text/html')) {
      var _getPastePreProcess = (0, _pastePreProcess.default)(dataTransfer.getData('text/html'), formatTransformMap, clearAllStyles, defaultStylesMap),
          pasteSource = _getPastePreProcess.converterName,
          converter = _getPastePreProcess.converter;

      return {
        type: 'html',
        pasteSource: pasteSource,
        converter: converter
      };
    }

    if (dataTransfer.getData('text/plain')) {
      return {
        type: 'plaintext',
        converter: identity
      };
    }
  }

  return {
    type: 'unknown',
    converter: identity
  };
};

exports.getPasteInfo = getPasteInfo;